var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 7,
    r: 6.25,
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.495495 20.445C0.189002 20.7237 0.166415 21.198 0.445045 21.5045C0.723675 21.811 1.19801 21.8336 1.5045 21.555L0.495495 20.445ZM11.4955 10.445L0.495495 20.445L1.5045 21.555L12.5045 11.555L11.4955 10.445Z",
    fill: "current",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 23.5L24 23.5",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 20L19 20",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5H10C7.79086 5 6 6.79086 6 9V25.5C6 27.7091 7.79086 29.5 10 29.5H24C26.2091 29.5 28 27.7091 28 25.5V9C28 6.79086 26.2091 5 24 5H22",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7759 9.642C17.8405 9.642 18.5708 9.1093 18.9299 8.6446L19.8583 9.5286C19.5489 9.948 18.5585 10.8886 16.7387 10.8886C14.919 10.8886 13.5078 9.9253 13.0498 8.282H11.75L11.9604 7.432H12.9012C12.8888 7.3186 12.8888 7.194 12.8888 7.0693C12.8888 6.9446 12.8888 6.8313 12.9012 6.718H11.75L11.9604 5.868H13.0373C13.4954 4.2133 14.919 3.25 16.7511 3.25C18.5585 3.25 19.5489 4.1906 19.8583 4.6213L18.9299 5.494C18.5708 5.0406 17.8652 4.4966 16.813 4.4966C15.9712 4.4966 15.0799 4.9046 14.6838 5.868H17.7909L17.5929 6.718H14.4857C14.4734 6.8313 14.4734 6.9446 14.4734 7.0693C14.4734 7.194 14.4734 7.3186 14.4857 7.432H17.4444L17.2339 8.282H14.6962C15.0924 9.234 15.9589 9.642 16.7759 9.642Z",
    fill: "current",
    stroke: "none"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmc);
export default __webpack_public_path__ + "static/media/emc.b522bfb2da4bb269365ea67e79c6d9e3.svg";
export { ForwardRef as ReactComponent };